import React from "react";
import { Phone, Mail } from "lucide-react";

export default function MobileStickyBar({ onRequestQuote }) {
  return (
    <div
      data-testid="mobile-sticky-bar"
      className="md:hidden fixed bottom-0 inset-x-0 z-[1500] bg-[#0a1a17]/95 backdrop-blur-xl border-t border-[#c99658]/20 px-3 py-2.5"
    >
      <div className="flex items-center gap-2">
        <a
          className="flex-1 flex items-center justify-center gap-2 py-3 min-h-[44px] rounded-none bg-white/5 border border-white/15 text-white text-[11px] font-raleway tracking-[0.32em] uppercase font-medium"
          href="tel:7207703795"
          data-testid="sticky-call"
        >
          <Phone className="w-4 h-4" />
          Call
        </a>
        <a
          href="mailto:sales@viewluxcolorado.com"
          data-testid="sticky-email"
          className="flex-1 flex items-center justify-center gap-2 py-3 min-h-[44px] rounded-none bg-white/5 border border-white/15 text-white text-[11px] font-raleway tracking-[0.32em] uppercase font-medium"
        >
          <Mail className="w-4 h-4" />
          Email
        </a>
        <button
          data-testid="sticky-quote"
          onClick={onRequestQuote}
          className="flex-1 py-3 min-h-[44px] rounded-none bg-[#C99658] text-[#0a1a17] text-[11px] font-raleway tracking-[0.32em] uppercase font-semibold"
        >
          Quote
        </button>
      </div>
    </div>
  );
}
